import { Link } from 'react-router-dom';

import { Breadcrumb, DropdownMenu, MoreButton, PageTitle } from '@ingrid/luterkort-react';

import { useTranslation } from '~src/i18n/use-translation';

interface Props {
  current: string;
}

export function Breadcrumbs({ current }: Props) {
  const { t } = useTranslation();

  return (
    <PageTitle.Stack>
      <Breadcrumb aria-label={t('common.breadcrumbs')}>
        <DropdownMenu.Root modal={false}>
          <DropdownMenu.Trigger>
            <MoreButton style={{ display: 'inline', verticalAlign: 'top' }} />
          </DropdownMenu.Trigger>

          <DropdownMenu.Content align="start" sideOffset={6} style={{ minWidth: 140, width: 'auto' }}>
            <DropdownMenu.Item asChild>
              <Link to="../..">{t('common.settings')}</Link>
            </DropdownMenu.Item>
          </DropdownMenu.Content>
        </DropdownMenu.Root>

        <Link to="..">{t('common.addressBook')}</Link>

        <a aria-current="page">{current}</a>
      </Breadcrumb>
    </PageTitle.Stack>
  );
}
